import React from "react";

interface GridViewProps<T> {
  data: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  columns?: number;
  className?: string; // ✅ Add this
}

function GridView<T>({
  data,
  renderItem,
  columns,
  className = "", // ✅ Default empty
}: GridViewProps<T>) {
  const gridCols = ` xl:grid-cols-${columns}   `;

  return (
    <div className={`grid   ${columns}    gap-4 ${className}`}>
      {Array.isArray(data) &&
        data.map((item, index) => (
          <div key={index}>{renderItem(item, index)}</div>
        ))}
    </div>
  );
}

export default GridView;
